import { render, staticRenderFns } from "./PracticalExamInfo.vue?vue&type=template&id=6895b212"
import script from "./PracticalExamInfo.vue?vue&type=script&lang=ts"
export * from "./PracticalExamInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports